import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

import styles from './Preloader.module.css';

export const Preloader = () => (
  <div className={styles.loaderContainer}>
    <div className={styles.overlay} />

    <Swiper
      autoplay={{
        delay: 700,
      }}
      modules={[Autoplay]}
      direction="vertical"
      className="mySwiper"
      loop
    >
      <SwiperSlide>
        <p className={styles.text}>WE</p>
      </SwiperSlide>
      <SwiperSlide>
        <p className={styles.text}>MAKE</p>
      </SwiperSlide>
      <SwiperSlide>
        <p className={styles.text}>KITCHEN</p>
      </SwiperSlide>
    </Swiper>
    <div className={styles.barBox}>
      <div className={styles.progress} />
    </div>
  </div>
);
